<div id="loading-mask"
     [class.ct-active]="showMask"
     [class.ct-impersonate]="impersonationService?.impersonationUser">
    <div class="loading-mask-content"></div>
</div>